import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('REDIRECT', {
  REDIRECT: null
});
